module.exports = __webpack_public_path__ + "static/uoLogo-e3c15122902821ecc94c0262c6587dfe.png";